import * as React from "react";
import type { BadgeProps } from "../types";
import styles from "./index.module.css";

function Badge(props: BadgeProps) {
  function variantCss() {
    return " " + (props.variant ? styles[props.variant] : styles.info);
  }

  return (
    <span
      className={`${styles.badge}${variantCss()}`}
      aria-label={props.ariaLabel || props.badgeText}
    >
      {props.badgeText}
    </span>
  );
}

export default Badge;
